import React from 'react';
import './Avatar.css';

interface AvatarProps {
  imageUrl?: string;
  name?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const Avatar: React.FC<AvatarProps> = ({ 
  imageUrl, 
  name = '', 
  size = 'medium',
  className = '',
  onClick,
  style
}) => {
  const [loadError, setLoadError] = React.useState(false);

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const classes = `avatar avatar--${size} ${className}`.trim();

  if (!imageUrl || loadError) {
    return (
      <div className={classes} onClick={onClick} style={style}>
        <div className="avatar__initials">
          {name ? getInitials(name) : ''}
        </div>
      </div>
    );
  }

  return (
    <div className={classes} onClick={onClick} style={style}>
      <img 
        src={imageUrl} 
        alt={name || 'Profile'} 
        className="avatar__image"
        onError={() => setLoadError(true)}
      />
    </div>
  );
}; 